import { AppState } from 'Store'

const getSurveyData = (state: AppState) => state.survey.survey.data
const getSurveyDataEntries = (state: AppState) => state.survey.survey.data.entries
const getSurveyResultsData = (state: AppState) => state.survey.survey.results
const getSurveyResultsFilters = (state: AppState) =>
	// TODO NC-5191
	(state.survey.survey as any).results_filters
const getSurveyRequestParamsSelector = (state: AppState) => state.survey.survey.requestParams
const surveyNeedSave = (state: AppState) => state.survey.survey.needSave
const optionNeedSave = (state: AppState) => state.survey.option.needSave
const attemptNeedSave = (state: AppState) => state.survey.attempt.needSave
const getSurveyFormErrors = (state: AppState) => state.survey.survey.formErrors
const getOptionSaveChain = (state: AppState) => state.survey.option.saveChain
const getAttemptData = (state: AppState) => state.survey.attempt.data

export const surveySelector = {
	getSurveyData,
	getSurveyDataEntries,
	getSurveyResultsData,
	getSurveyResultsFilters,
	getSurveyRequestParamsSelector,
	surveyNeedSave,
	optionNeedSave,
	attemptNeedSave,
	getSurveyFormErrors,
	getOptionSaveChain,
	getAttemptData,
}
